import React from 'react';
import AppShell from '../components/AppShell';

/**
 * /legal — Phase 7 · Change 4
 *
 * Static, single-page legal centre: Terms of Service · Risk Disclosure ·
 * Privacy Policy. All copy is authored in-line so we don't need a CMS.
 * Anchors let the avatar-menu deep-link into a specific section later.
 */
export default function Legal() {
  return (
    <AppShell>
      <div className="legal-page" data-testid="legal-page">
        <h1>Legal</h1>
        <p style={{ color: '#6b6580', fontSize: 14, marginBottom: 24 }}>
          Please review these documents before trading on Clanster. Last updated: February 2026.
        </p>

        <section id="terms" data-testid="legal-terms">
          <h2>Terms of Service</h2>
          <p>
            By using Clanster you agree to our fair-use rules: no fraud, no market manipulation,
            no misleading verification claims, and no abusive behaviour toward other users. Clanster
            reserves the right to suspend accounts that violate these terms. Trading fees are 11%
            per trade (5% creator royalty, 5% platform, 1% referrer) or 10% if the account has no
            referrer. All fees are surfaced live in the trading sheet before you confirm.
          </p>
        </section>

        <section id="risk" data-testid="legal-risk">
          <h2>Risk Disclosure</h2>
          <p>
            Clanster is an experimental social-trading platform. "Bit" prices follow a
            transparent linear price curve — the price you receive when you sell depends on how many Bits are
            currently minted. You can lose Points on any trade. Points are not currency,
            securities, or an investment. Never trade more than you can comfortably lose.
            Past creator performance is not a guarantee of future price movement.
          </p>
        </section>

        <section id="privacy" data-testid="legal-privacy">
          <h2>Privacy Policy</h2>
          <p>
            We store the minimum data required to run the platform: your email, display name,
            handle, wallet balance, trade history, and verification records. When you verify with
            X (Twitter) via OAuth, we store only your X user ID and username — nothing else. We
            never sell your data, and we never post on your behalf. Data export and account
            deletion requests can be sent to <b>support@clanster.xyz</b>.
          </p>
        </section>
      </div>
    </AppShell>
  );
}
